import React from 'react';

import AppWrapper from '../../components/appWrapper/appWrapper';
import { FollowUs } from '../../components/followUs/followUs';
import useScrollToLocation from '../../hooks/useScrollToLocation';
import BusinessBenefits from './components/businessBenefits/businessBenefits';
import Faqs from './components/faqs/faqs';
import HeroSection from './components/heroSection/heroSection';
import { PataPay } from './components/pataPay/pataPay';
import { SignUpProcess } from './components/signUpProcess/signUpProcess';
import { HydrotherapyTestimoninal } from './components/testimoninal/testimoninal';
import { TopFeatures } from './components/topFeatures/topFeatures';

export const BusinessHydrotherapy = () => {
  useScrollToLocation();

  return (
    <>
      <AppWrapper>
        <HeroSection />

        <TopFeatures />

        <PataPay />

        <BusinessBenefits />
        <HydrotherapyTestimoninal />

        <SignUpProcess />

        <Faqs />
        <FollowUs />
      </AppWrapper>
    </>
  );
};
